<template>
  <div>
    <div class="box">
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <div class="field has-addons has-text-centered is-vcentered">
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getPrev()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getNext()"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
        <h5 class="title is-5 ml-3 mt-2">{{ startDate }} ～ {{ endDate }}</h5>
      </div>
      <BarChart v-bind="barChartProps" />
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import common from "@/imsr-common";
import { useRoute } from "vue-router";
import { ref, computed } from "vue";
import { Chart, registerables } from "chart.js";
import VueElementLoading from "vue-element-loading";
import { BarChart, useBarChart } from "vue-chart-3";
Chart.register(...registerables);

export default {
  components: {
    VueElementLoading,
    BarChart,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRoute();
    const aggrList = ref();
    const isLoading = ref(false);
    const baseDate = ref(null);
    const startDate = ref();
    const endDate = ref();
    const nextDate = ref();
    const prevDate = ref();
    const data = ref([]);
    const label = ref([]);
    const color = ref(["rgba(54, 162, 235, 0.2)"]);
    const color2 = ref(["rgb(54, 162, 235)"]);

    const chartData = computed(() => ({
      labels: label.value,
      datasets: [
        {
          label: "Count",
          data: data.value,
          borderWidth: 1,
          backgroundColor: color.value,
          borderColor: color2.value,
        },
      ],
    }));

    const options = {
      scales: {
        y: {
          min: 0,
          suggestedMax: 10,
        },
      },
    };

    const { barChartProps, barChartRef } = useBarChart({
      chartData: chartData,
      options,
    });

    const getList = async () => {
      isLoading.value = true;
      try {
        const date = common.makeDate2(baseDate.value);
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          startDate: date.start + "00",
          endDate: date.end + "23",
        };
        startDate.value = date.startStr;
        endDate.value = date.endStr;
        nextDate.value = date.nextDate;
        prevDate.value = date.prevDate;
        const res = await imsr.imsrGetApi("/events/hour", params);
        let buf = [];
        res.years.forEach(function(years) {
          years.months.forEach(function(month) {
            month.days.forEach(function(days) {
              if (!buf[days.day]) {
                buf[days.day] = 0;
              }
              days.hours.forEach(function(hours) {
                hours.devices.forEach(function(device) {
                  buf[days.day] += device.count;
                });
              });
            });
          });
        });
        data.value = [];
        label.value = [];
        color.value = [];
        color2.value = [];
        buf.forEach(function(element, index) {
          data.value.push(element);
          label.value.push(index);
          if (element > 4) {
            color.value.push("rgba(255, 99, 132, 0.2)");
            color2.value.push("rgba(255,99,132,1)");
          } else {
            color.value.push("rgba(54, 162, 235, 0.2)");
            color2.value.push("rgb(54, 162, 235)");
          }
        });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
      isLoading.value = false;
    };
    getList();

    const getPrev = () => {
      baseDate.value = prevDate.value;
      getList();
    };

    const getNext = () => {
      baseDate.value = nextDate.value;
      getList();
    };

    return {
      aggrList,
      isLoading,
      startDate,
      endDate,
      nextDate,
      prevDate,
      getPrev,
      getNext,
      chartData,
      barChartProps,
      barChartRef,
    };
  },
};
</script>
<style>
.has-event {
  padding: 0;
}
</style>
